import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/** Material Design's "fort" icon (towers and a gate), which @material-ui/icons 4.9 doesn't have. Used for Dungeons & Raids. */
export default function FortIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M21 3v2h-2V3h-2v2h-2V3h-2v4l2 2v1H9V9l2-2V3H9v2H7V3H5v2H3V3H1v4l2 2v6l-2 2v4h9v-3c0-1.1.9-2 2-2s2 .9 2 2v3h9v-4l-2-2V9l2-2V3h-2z" />
    </SvgIcon>
  );
}
